import { observer } from "mobx-react-lite";
import type DistributorRefundsViewModel from "viewModels/timeCharges/distributors/distributorRefunds/distributorRefundsViewModel";
import styles from "components/Toolbar/toolbar.module.scss";
import Button from "@edaz/edazkit/Button/index";
import { formatAmount } from "utils/localizations";
import React from "react";

interface DistributorsToolbarProps {
  vm: DistributorRefundsViewModel;
}

const DistributorsToolbar: React.FunctionComponent<DistributorsToolbarProps> = observer(props => {
  const { vm } = props;

  return (
    <div className={styles.toolbar}>
      <div className="row">
        <div className="col-12 col-lg-6 py-4 text-center text-md-left">
          {vm.isUserAllowedToEdit && (
            <>
              <Button
                disabled={!vm.isApprovalAllowed || vm.busyWatcher.isBusy}
                className="rounded"
                size="sm"
                onClick={vm.onApproveClick}>
                {vm.translate("approveSelected")}
              </Button>
              <Button
                disabled={!vm.isRefundGenerationAllowed || vm.busyWatcher.isBusy}
                className="rounded"
                size="sm"
                onClick={vm.onGenerateRefundClick}>
                {vm.translate("generateRefund")}
              </Button>
            </>
          )}
        </div>
        <div className="col-sm-6 col-lg-3 py-5 border-right text-center text-lg-right">
          <span className="text-success font-weight-bold mr-lg-2">
            {vm.translate("forRefund").replace("%amount%", formatAmount(vm.refundAmount) ?? "")}
          </span>
        </div>
        <div className="col-sm-6 col-lg-3 py-5 text-center text-lg-right">
          <span className="font-weight-bold">
            {vm.translate("total").replace("%amount%", formatAmount(vm.totalRefundAmount) ?? "")}
          </span>
        </div>
      </div>
    </div>
  );
});

export default DistributorsToolbar;
